<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Fraværsanmodning</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <Tabs
          v-if="isShowTabs"
          class="marg-1-bottom"
          :selected="selectedTab"
          :tabs="[
          {id: 'request', title: 'Anmod om fravær'},
          {id: 'list', title: 'Dine fraværsanmodninger'}]"
          @select="selectedTab = $event">
        </Tabs>
        <UserRequestList v-if="selectedTab === 'list'" :isUserView="true"></UserRequestList>
        <template v-if="selectedTab === 'request'">
          <template v-if="isMultipleSchoolsActive && !activeSchoolId">
            <div class="d-group">
              <label class="d-label">Vælg skole</label>
              <select v-model="activeSchoolId" @change="onChangeActiveSchoolId">
                <option v-for="school in userSchoolsSorted" :value="school.id">
                  {{ school.name }}
                </option>
              </select>
            </div>
          </template>
          <template v-else-if="activeSchoolId">
            <div class="do-spinner__container">
              <div class="do-spinner do-spinner--large"></div>
            </div>
          </template>
          <template v-else>
            <UserAbsence
              :resetCounter="resetAbsenceCounter"
              @setSubject="setSelectedSubject">
            </UserAbsence>
            <div class="d-group">
              <label class="d-label">Dato</label>
              <DatepickerRange
                :allowSameDate="true"
                :startdate="date"
                @startchanged="setStartDate"
                @endchanged="setEndDate">
              </DatepickerRange>
            </div>
            <div class="time-changer__group">
              <label class="d-label">Tid</label>
              <TimeChanger
                :showIcon="true"
                :start="startTime"
                :end="endTime"
                :isFiveMinutesInterval="false"
                @updateStart="setStartTime"
                @updateEnd="setEndTime">
              </TimeChanger>
            </div>
            <div class="d-group marg-1-top">
              <label class="d-label">Evt. note</label>
              <textarea class="do-input" v-model="note"></textarea>
            </div>
          </template>
        </template>
      </div>
      <div class="d-modal__buttons d-modal__buttons__padding"
           v-if="selectedTab === 'request'"
           style="padding: 1rem;">
        <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
        <button class="do-bttn do-bttn--submit do-bttn--submit--disabled"
                v-if="!isValidated">
          {{ $t('vue2.common.create') }}
        </button>
        <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSubmitting}" v-else
                @click="submit">{{ $t('vue2.common.create') }}
        </button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal'
import eventbus from '../../eventbus'
import {mapGetters} from 'vuex'
import moment from 'moment'
import DatepickerRange from '../datepicker/DatePickerRange.vue'
import TimeChanger from '../TimeChanger.vue'
import UserAbsence from './UserAbsence.vue'
import Tabs from '../common/Tabs'
import UserRequestList from './UserRequestList.vue'

export default {
  components: {UserRequestList, UserAbsence, DatepickerRange, TimeChanger, DModal, Tabs},
  props: {
    isShowTabs: {
      type: Boolean,
      default: true
    },
    editRequest: {
      default: null
    }
  },
  data () {
    return {
      date: moment(),
      startDate: moment(),
      endDate: moment(),
      startTime: moment().set({'hour': 8, 'minutes': 0}),
      endTime: moment().set({'hour': 16, 'minutes': 0}),
      selectedSubject: null,
      note: '',
      isSubmitting: false,
      activeSchoolId: null,
      isMultipleSchoolsActive: false,
      selectedTab: 'request',
      resetAbsenceCounter: 0
    }
  },
  computed: {
    ...mapGetters([
      'userCalendars',
      'schoolId',
      'schoolFeatures'
    ]),
    user () {
      return this.$store.state.user
    },
    userSchools () {
      return this.user && this.user.schools ? this.user.schools : []
    },
    userSchoolsSorted () {
      return this.userSchools.sort((a, b) => a.name.localeCompare(b.name))
    },
    isValidated () {
      return this.selectedSubject
    },
    dbEventStart () {
      const date = moment(this.startDate).format('YYYY-MM-DD')
      const time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      const date = moment(this.endDate).format('YYYY-MM-DD')
      const time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  methods: {
    resetForm () {
      this.startDate = moment()
      this.endDate = moment()
      this.startTime = moment().set({hour: 8, minutes: 0})
      this.endTime = moment().set({hour: 16, minutes: 0})
      this.selectedSubject = null
      this.note = ''
      this.resetAbsenceCounter++
    },
    onChangeActiveSchoolId () {
      this.readSchoolYears()
      this.$nextTick(_ => {
        console.log(document.getElementById('app'))
      })
    },
    readSchoolYears () {
      this.isLoadingSchoolYears = true
      docendo.schoolYearsRead(this.activeSchoolId, {}, 'name', data => {
        this.schoolYears = data
        this.isLoadingSchoolYears = false
      })
    },
    setSelectedSubject (subject) {
      this.selectedSubject = subject
    },
    setStartDate (payload) {
      this.startDate = payload
    },
    setEndDate (payload) {
      this.endDate = payload
    },
    setStartTime (payload) {
      this.startTime = payload
    },
    setEndTime (payload) {
      this.endTime = payload
    },
    submit () {
      this.isSubmitting = true
      const schoolId = this.selectedSubject.school_id
      const startTime = this.dbEventStart
      const endTime = this.dbEventEnd
      const requestNote = this.note
      const subjectId = this.selectedSubject.id
      docendo.createRequest(schoolId, subjectId, startTime, endTime, requestNote, success => {
        this.showToast('Anmodning oprettet', true)
        this.isSubmitting = false
        this.selectedTab = 'list'
        this.resetForm()
      }, failure => {
        this.showToast(failure, false)
        this.isSubmitting = false
      })
    },
    showToast (message, success) {
      eventbus.toast = {text: message, success}
    }
  }
}
</script>

<style scoped>
.d-modal {
  width: 850px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.d-modal__close {
  font-size: 16px !important;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 2rem - 52px - 60px);
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.do-spinner__container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}

textarea.do-input {
  min-height: 120px
}
</style>



// WEBPACK FOOTER //
// UserRequest.vue?fea14d30